import { Pipe, PipeTransform } from '@angular/core';
import { TimezoneLabels } from '@shared/constants/constants';
import * as moment from 'moment';

@Pipe({
    name: 'timezoneLabel'
})
export class TimezoneLabelPipe implements PipeTransform {
    transform(time: Date, timezoneId: string): string {
        let timezoneLabel = '';
        let isDST = false;

        isDST = moment(time).isDST();

        if (TimezoneLabels?.find(x => x.id === timezoneId)) {
            timezoneLabel = TimezoneLabels?.find(x => x.id === timezoneId)?.labels?.find(y => y.isDST === isDST)?.text;
        }

        return timezoneLabel;
    }
}
